import React from "react";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
  SettingsOptionHeading,
} from "../../styles";
import { ButtonGroup, NumberInput, Select } from "@caelor/ui";
import { useTranslation } from "react-i18next";
import {
  BOOLEAN_OPTIONS,
  CORNERS_OPTIONS,
  getPaginationOptions,
} from "./defaults";
import { useUpcomingBirthdayStore } from "../../../../../../stores/use-upcoming-birthdays-store";
import ColorPicker from "../../../../../../components/ui/color-picker/ColorPicker";
import { DEFAULT_ACCENT_COLOR } from "../../../../../../features/people/defaults";
import { useOpticsStore } from "../../../../../../stores/use-optics-store";
import { useStyleguideColors } from "../../../../../../hooks/use-styleguide-colors";

function LayoutSettings() {
  const { t } = useTranslation();

  const { data, updateData } = useUpcomingBirthdayStore((state) => ({
    data: state.data,
    updateData: state.updateData,
  }));

  const { isCosmosInstalled, styleguideSetup } = useOpticsStore((state) => ({
    isCosmosInstalled: state.isCosmosInstalled,
    styleguideSetup: state.styleguideSetup,
  }));

  const styleguideColors = useStyleguideColors({
    styleguideSetup,
  });

  const PaginationOptions = getPaginationOptions(t);

  return (
    <>
      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("display-options")}</SettingsOptionHeading>

        <OptionContainer>
          <OptionLabel>{t("pagination")}</OptionLabel>
          <OptionContent>
            <Select
              options={PaginationOptions}
              value={PaginationOptions.find(
                ({ value }) => value === data.pagination
              )}
              onChange={({ value }) =>
                updateData({ value: { pagination: value } })
              }
            />
          </OptionContent>
        </OptionContainer>

        <OptionContainer>
          <OptionLabel>{t("per-page")}</OptionLabel>
          <OptionContent>
            <NumberInput
              value={data.maxNumberOfItems}
              setValue={(value) =>
                updateData({ value: { maxNumberOfItems: value } })
              }
              min={1}
              isFullWidth
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>

      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("link")}</SettingsOptionHeading>
        <OptionContainer>
          <OptionLabel>{t("new-tab")}</OptionLabel>
          <OptionContent>
            <ButtonGroup
              items={BOOLEAN_OPTIONS}
              value={data?.openInNewTab ?? true}
              onClick={(isOn) =>
                updateData({
                  value: { openInNewTab: isOn },
                })
              }
              i18n={t}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>

      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("styling-options")}</SettingsOptionHeading>

        <OptionContainer>
          <OptionLabel>{t("corners")}</OptionLabel>
          <OptionContent>
            <ButtonGroup
              items={CORNERS_OPTIONS}
              value={data.borderRadius}
              options={{ input: true }}
              onClick={(value) =>
                updateData({ value: { borderRadius: value } })
              }
              onChange={({ target: { value } }) => {
                if (value.length < 4) {
                  updateData({ value: { borderRadius: value } });
                }
              }}
              i18n={t}
            />
          </OptionContent>
        </OptionContainer>
        <OptionContainer>
          <OptionLabel alignToTop>{t("colors")}</OptionLabel>
          <OptionContent>
            <ColorPicker
              hideColorTiles
              value={{
                accent:
                  data.accentColor ||
                  styleguideColors?.accent ||
                  DEFAULT_ACCENT_COLOR,
              }}
              onChange={({ accent }) => {
                updateData({ value: { accentColor: accent } });
              }}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
    </>
  );
}

export default LayoutSettings;
